import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const CIPIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.875 3.375C3.59886 3.375 3.375 3.59886 3.375 3.875V20.125C3.375 20.4011 3.59886 20.625 3.875 20.625H20.125C20.4011 20.625 20.625 20.4011 20.625 20.125V3.875C20.625 3.59886 20.4011 3.375 20.125 3.375H3.875ZM1.875 3.875C1.875 2.77043 2.77043 1.875 3.875 1.875H20.125C21.2296 1.875 22.125 2.77043 22.125 3.875V20.125C22.125 21.2296 21.2296 22.125 20.125 22.125H3.875C2.77043 22.125 1.875 21.2296 1.875 20.125V3.875Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4531 8.9955C18.7318 9.30199 18.7092 9.77633 18.4027 10.055L12.9706 14.9932C12.6817 15.2558 12.2397 15.2529 11.9544 14.9866L9.47753 12.6749L6.23312 15.407C5.91628 15.6738 5.44314 15.6333 5.17633 15.3164C4.90952 14.9996 4.95008 14.5265 5.26691 14.2597L9.02 11.0992C9.31028 10.8547 9.7374 10.8656 10.0148 11.1245L12.4728 13.4186L17.3937 8.94505C17.7002 8.66642 18.1745 8.68901 18.4531 8.9955Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8896 9.5C13.8896 9.08579 14.2254 8.75 14.6396 8.75H17.8989C18.3131 8.75 18.6489 9.08579 18.6489 9.5V12.6605C18.6489 13.0747 18.3131 13.4105 17.8989 13.4105C17.4847 13.4105 17.1489 13.0747 17.1489 12.6605V10.25H14.6396C14.2254 10.25 13.8896 9.91421 13.8896 9.5Z"
          fill="currentColor"
        />
      </SvgIcon>
    );
  })
);
